import { motion } from "framer-motion";

interface Partner {
  name: string;
  description: string;
  logo: string;
}

const partners: Partner[] = [
  { 
    name: "Tabela FIPE", 
    description: "Referência de preços",
    logo: "https://www.fipe.org.br/Content/img/logo_oficial_2025.jpg"
  },
  { 
    name: "Copart", 
    description: "Leilões",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Copart_logo.svg/250px-Copart_logo.svg.png"
  },
  { 
    name: "Superbid", 
    description: "Leilões",
    logo: "https://www.superbid.net/static/others/logo-superbid.webp"
  },
  { 
    name: "Detran SP", 
    description: "Dados veiculares",
    logo: "https://www.detran.sp.gov.br/702a783633529610cd8381ac4f5c7b5b.iix"
  },
];

export function Partners() {
  return (
    <section className="py-16 md:py-20 border-y border-border/50 bg-muted/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
            Dados de fontes confiáveis
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16"
        >
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.1 * index }}
              className="flex flex-col items-center gap-2 group"
            >
              <div className="p-3 rounded-lg bg-white/90 group-hover:bg-white transition-colors duration-300 shadow-sm">
                <img 
                  src={partner.logo} 
                  alt={`Logo ${partner.name}`}
                  className="h-10 w-auto object-contain"
                />
              </div>
              <span className="text-xs text-muted-foreground">
                {partner.description}
              </span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
